export default __webpack_public_path__ + "static/media/warning-circle-purple.9b2e8404.svg";